import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'feedRule'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      feed_id: this.number(0),
      network_id: this.number(0),
      name: this.string(''),
      type: this.string(''),
      iterations: this.number(0),
      frequency: this.string(''),
      enabled: this.number(0),
      rule: this.attr({}),
      keyword_filter: this.attr({}),
      lists: this.attr({}),
      list_items: this.attr({}),
      channel_filter: this.attr({}),
      site_filter: this.attr({}),
      posts_count: this.number(0),
      channels_count: this.number(0),
    };
  }

  static methodConf = {
    http: {
      url: process.env.VUE_APP_APIS_FETCHER_ADMIN,
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/feedRules',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/feedRules/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/feedRules',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/feedRules/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/feedRules/:id',
          method: 'delete',
        },
      },
    },
  }
}
